<template>
  <div class="template-container">
    <div class="row g-4">
      <!-- 사이드 네비게이션 -->
      <aside class="col-12 col-md-3 col-lg-2">
        <MyPageSubNav />
      </aside>

      <!-- 메인 콘텐츠 -->
      <main class="col-12 col-md-9 col-lg-10">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup>
/* ===========================================================================
 * 1) Imports
 * =========================================================================== */
import MyPageSubNav from "@/views/mypage/MyPageSubNav.vue";
</script>
